module.exports = __webpack_public_path__ + "static/media/47.60522109.png";